/*
 * @Author: luting
 * @Date: 2022-04-15 16:33:21
 * @lastEditors: luting
 * @LastEditTime: 2023-02-15 16:49:28
 */

import { UpdateQueueType } from './types';
import { Dispatch } from 'redux';
import { UPDATE_QUEUE, ADD_QUEUE, DELETE_QUEUE, ADD_PACK, SET_OPERATION, DIFF_QUEUE } from 'root/store/constant';

export const updateQueue = (payload: UpdateQueueType) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: UPDATE_QUEUE,
      payload: { ...payload },
    });
  };
};

export const addQueue = (payload: any) => ({
  type: ADD_QUEUE,
  payload,
});

export const addPack = (payload: any) => ({
  type: ADD_PACK,
  payload,
});

export const deleteQueue = (payload: { viewId: string }) => ({
  type: DELETE_QUEUE,
  payload,
});

export const setOperationPackage = (payload: string) => ({
  type: SET_OPERATION,
  payload,
});

export const diffQueue = (payload: UpdateQueueType) => ({
  type: DIFF_QUEUE,
  payload,
});